module.exports = __webpack_public_path__ + "static/img/img_guide2.c80cb3c6.png";